import Button from 'components/features/pfm/Button/Button'
import { FC, useCallback, useMemo } from 'react'
import { OnboardingPagePreset } from 'components/features/creditCard/creditCardOnboarding/OnboardingPagePreset/OnboardingPagePreset'
import styles from 'components/features/creditCard/creditCardOnboarding/SuccessStepPage/SuccessStepPage.styl'
import { Link } from 'react-router-dom'
import { useStoreDispatch, useStoreSelector } from 'helpers/reactReduxHelpers'
import { INDICATOR_CARD_SUCCESS_STEP } from 'components/features/pfm/StepIndicator/StepIndicator'
import { GetCCStateAction } from 'components/features/creditCard/creditCardStore/actions'
import { getMemberInfoActionCreator } from 'actions/memberActions'
import { getMixedAccountsActionCreator } from 'actions/linkageActions'

export const SuccessStepPage: FC = () => {
  const address = useStoreSelector((state) => state.data.creditCard.person_data?.address)

  const dispatch = useStoreDispatch()
  const getCardState = useCallback(() => {
    dispatch(new GetCCStateAction())
    dispatch(getMemberInfoActionCreator())
    dispatch(getMixedAccountsActionCreator.request({}))
  }, [dispatch])

  const addressValues = useMemo(() => {
    if (!address) {
      return null
    }

    return [
      `${ address.number } ${ address.street }`,
      `${ address.refinement }`,
      `${ address.city.name }, ${ address.city.state.code } ${ address.zip5 }`,
    ].map((str) => str.trim()).filter(Boolean)
  }, [address])

  const cardChild = useMemo(() => (
    <>
      <div className={ styles.note } data-qa-marker='form-note' data-qa-type='shipment'>
        It should arrive within 7-10 business days at this address:
      </div>
      { addressValues && (
        <div className={ styles.address } data-qa-marker='shipment-address'>
          <h4 data-qa-type='header'>Shipping Address</h4>
          <pre data-qa-type='value'>
            { addressValues.join('\n') }
          </pre>
        </div>
      )}
      <div className={ styles.note } data-qa-marker='form-note' data-qa-type='payment'>
        In the meantime, you can start using your credentials to make purchases online.
      </div>
    </>
  ), [addressValues])

  return (
    <OnboardingPagePreset
      step={ INDICATOR_CARD_SUCCESS_STEP }
      title={ (
        <>
          Congratulations! <br />
          Your card is being shipped.
        </>
      ) }
      card={ cardChild }
      progressPercent={ 100 }
    >
      <div className={ styles.preset }>
        <Link to='/credit-card'>
          <Button
            text='Close'
            fullWidth
            qaMarker='cancel-button'
            onClick={ getCardState }
          />
        </Link>
      </div>
    </OnboardingPagePreset>
  )
}
